import React, { useState, useEffect } from "react";
import Choices from "choices.js";
import "choices.js/public/assets/styles/choices.min.css";
import SideBar from "../Includes/Sidebar";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormik } from 'formik';
import * as Yup from 'yup';
//pass request back end
import axios from "axios";
import UserProfile from "../Assets/images/single-user.png";
import { API_BASE_URL, fetchOptionsInsights, fetchOptionsPlans } from "../../global";
import PayPalButtonUI from '../Paypal/PayPalButtonUI';

const SettingsPage = ({triggerTokenFetch, defaultStep = "step1"}) => {
  
  // useEffect(() => {
  //   const workFunctionSelect = document.getElementById("workFunction");
  //   if (workFunctionSelect) {
  //     for (let option of workFunctionSelect.options) {
  //       option.selected = false;
  //     }
  //     new Choices(workFunctionSelect, {
  //       searchEnabled: true,
  //       shouldSort: false,
  //       placeholderValue: "Select Your Professional Title",
  //       searchPlaceholderValue: "Search titles...",
  //       itemSelectText: "",
  //       allowHTML: true,
  //     });
  //   }

  //   const navItems = document.querySelectorAll("#settings-nav li");
  //   const steps = document.querySelectorAll(".step-section");

  //   navItems.forEach((item) => {
  //     item.addEventListener("click", function () {
  //       const targetStep = this.getAttribute("data-step");

  //       steps.forEach((step) => {
  //         step.style.display = step.id === targetStep ? "flex" : "none";
  //       });

  //       navItems.forEach((li) => li.classList.remove("active"));
  //       this.classList.add("active");
  //     });
  //   });
  // }, []);

 useEffect(() => {
    const workFunctionSelect = document.getElementById("workFunction");
    if (workFunctionSelect) {
      for (let option of workFunctionSelect.options) {
        option.selected = false;
      }
      new Choices(workFunctionSelect, {
        searchEnabled: true,
        shouldSort: false,
        placeholderValue: "Select Your Professional Title",
        searchPlaceholderValue: "Search titles...",
        itemSelectText: "",
        allowHTML: true,
      });
    }

    const navItems = document.querySelectorAll("#settings-nav li");
    const steps = document.querySelectorAll(".step-section");

    function activateStep(stepId) {
      steps.forEach((step) => {
        step.style.display = step.id === stepId ? "flex" : "none";
      });

      navItems.forEach((li) => {
        if (li.getAttribute("data-step") === stepId) {
          li.classList.add("active");
        } else {
          li.classList.remove("active");
        }
      });
    }

    activateStep(defaultStep);

    navItems.forEach((item) => {
      item.addEventListener("click", function () {
        const targetStep = this.getAttribute("data-step");
        activateStep(targetStep);
      });
    });

  }, [defaultStep]);

    const [optionsInsights, setOptionsInsights] = useState([]);
    const [optionsPlans, setOptionsPlans] = useState([]);
    const [userData, setUserData] = useState([]);
    const [isSubmittingUser, setIsSubmittingUser] = useState(false);
    useEffect(() => {
      const loadInsights = async () => {
        // const insights = await fetchOptionsInsights();
        // setOptionsInsights(insights);
      };
      const loadPlans = async () => {
        const plansData = await fetchOptionsPlans();
        setOptionsPlans(plansData);
      };
      fetchUserDeatils();
      loadInsights();
      loadPlans();
    }, []);

  const fetchUserDeatils = async () => {
    try {
      const response = await axios.post(API_BASE_URL + "Ins_User_info", {
        user_id: localStorage.getItem("userid"),
        mode: "UserDetails"
      });

      const userData = response.data || null;
      //console.log(userData);

      if (userData?.data.length > 0) {
        setUserData(userData?.data?.[0]);
      }else{
        setUserData(null);
      }

    } catch (error) {
      console.error("Error fetching user:", error);
      //return []; // fallback on error
    }
  };

console.log(userData)
   const validationUser = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      user_id: localStorage.getItem("userid"),
      user_name: userData?.user_name || null,
      company_name: userData?.user_company || null,
      // insight_ids: userData?.ins_data?.map(item => item.pk_ins_id) || [],
      user_address: userData?.user_address || null,
      user_city: userData?.user_city || null,
      user_state: userData?.user_state || null,
      user_country: userData?.user_country || null,
      user_phone_num: userData?.user_phone_num || null,
    },
    validationSchema: Yup.object({
      user_name: Yup.string()
        .required("Name is required")
        .min(3, "Minimum 3 characters is required")
        .max(30, "Maximum 30 characters is required"),
      company_name: Yup.string()
        .required("Company name is required")
        .min(3, "Minimum 3 characters is required")
        .max(50, "Maximum 50 characters is required"),
      // insight_ids: Yup.array()
      //       .min(1, "At least one insight must be selected")
      //       .of(Yup.string().required()),
      user_address: Yup.string()
        .notRequired()
        .min(3, "Minimum 3 characters is required")
        .max(50, "Maximum 50 characters is required"),
      user_city: Yup.string()
        .notRequired()
        .min(3, "Minimum 3 characters is required")
        .max(30, "Maximum 30 characters is required"),
      user_state: Yup.string()
        .notRequired()
        .min(3, "Minimum 3 characters is required")
        .max(30, "Maximum 30 characters is required"),
      user_country: Yup.string()
        .notRequired()
        .min(3, "Minimum 3 characters is required")
        .max(30, "Maximum 30 characters is required"),

      user_phone_num: Yup.string()
        .notRequired()
        .matches(/^[0-9]{10,15}$/, "Phone number must be 10-15 digits"),
    }),
    onSubmit: async values => {
      // console.log(values);
      //disable login button
      setIsSubmittingUser(true)

      try {
        const response = await axios.post(
          API_BASE_URL+"Ins_User_Update",
          {
            ...values
          }
        )
       if (response.data && response.data.status && response.data.status == 1) {
          localStorage.setItem("username", values?.user_name)
          localStorage.setItem("userdocumentlabel", response?.data?.data?.[0]?.label || 'Project')
          toast.success(`Profile details updated successfully!`);
          setIsSubmittingUser(false)
          
        } else {
          toast.error("The user details could not be added. Please try again.", {
            autoClose: 3000, // 3 seconds in this example
          })
          setIsSubmittingUser(false)
        }
      } catch (error) {
        toast.error("The user details could not be added. Please try again.", {
          autoClose: 3000, // 3 seconds in this example
        })
        console.error("Error fetching data:", error)

        setIsSubmittingUser(false) // Re-enable the submit button
      } finally {
        setIsSubmittingUser(false) // Re-enable the submit button
      }

      //dispatch(loginUser(values, props.router.navigate));
    },
  })

  //Pament Use paypal start

 const [activeTab, setActiveTab] = useState("personal");
  const [selectedPrice, setSelectedPrice] = useState("0");
  const [perCreditRate, setPerCreditRate] = useState("0");
  const [UpgradeProcess, setUpgradeProcess] = useState(true);
  const [seletedPlan, setseletedPlan] = useState(null);
  // inside your component:
  const [paypalClicked, setPaypalClicked] = useState(false);
  const [status, setStatus] = useState(null); // null, 'success', 'failed'
  const [result, setResult] = useState({}); // data like orderID, amount, reason

  const handleSuccess = (data) => {
    setStatus("success");
    setResult(data);
    triggerTokenFetch();
    setPaypalClicked(false);
  };

  const handleFailure = (data) => {
    setStatus("failed");
    setResult(data);
    triggerTokenFetch();
    setPaypalClicked(false);
  };

  const handleResetPaymentStatus = () => {
    setStatus(null);
    setResult({});
    const defaultPlan = optionsPlans.find(p => p.pk_token_plan_id === 1) || optionsPlans[0];
    //const ratePerCredit = (defaultPlan.plan_pages / defaultPlan.plan_amount).toFixed(1);
    setSelectedPrice(`$${defaultPlan?.plan_amount}`);
    setPerCreditRate(`${defaultPlan?.plan_per_page_amount}/credit`);
    setseletedPlan(defaultPlan);
    triggerTokenFetch();
    setPaypalClicked(false);
  } 

  const handleCreditChange = (e) => {
    const price = parseFloat(e.target.getAttribute("data-price"));
    const rate = e.target.getAttribute("data-rate");
    const data = JSON.parse(e.target.getAttribute("data-details")); // if data is serialized

    setSelectedPrice(`$${price}`);
    setPerCreditRate(`${rate}/credit`);
    setseletedPlan(data);
  };


  useEffect(() => {
    if (optionsPlans.length > 0) {
      const defaultPlan = optionsPlans.find(p => p.pk_token_plan_id === 1) || optionsPlans[0];
      //const ratePerCredit = (defaultPlan.plan_pages / defaultPlan.plan_amount).toFixed(1);
      setSelectedPrice(`$${defaultPlan?.plan_amount}`);
      setPerCreditRate(`${defaultPlan?.plan_per_page_amount}/credit`);
      setseletedPlan(defaultPlan);
    }
  }, [optionsPlans]);

  //payment use paypal end

  //contact us start
  const validationSchema = Yup.object({
    contact_email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    contact_message: Yup.string()
      .required("Message is required")
      .min(3, "Message must be at least 3 characters"),
  });

  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false)
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      user_id: localStorage.getItem('userid'),
      contact_email: localStorage.getItem('useremail'),
      contact_message: "",
    },
    validationSchema,
    onSubmit: async values => {
      setIsSubmitting(true)

      try {
        const response = await axios.post(
          API_BASE_URL+"contact",
          {
            ...values
          }
        )
       if (response.data && response.data.status && response.data.status == 1) {
          toast.success("Message sent successfully, and we'll contact you soon.", {
            autoClose: 3000,
          });
          setShowModal(false)
          setIsSubmitting(false)
        } else {
          toast.error("The message details could not be added. Please try again.", {
            autoClose: 3000, // 3 seconds in this example
          })
          setIsSubmitting(false)
        }
      } catch (error) {
        toast.error("The message details could not be added. Please try again.", {
          autoClose: 3000, // 3 seconds in this example
        })
        console.error("Error fetching data:", error)

         setIsSubmitting(false)
      } finally {
         setIsSubmitting(false) // Re-enable the submit button
      }
    },
  });
//contact us end





  return (
    <div id="div2" className="right-ctn flexible flex align-items-center h-100">
      <div className="page-wrapper">
        <div className="page-content d-flex flex-column w-100 align-items-center justify-content-start">
          <div className="settings-wrapper-main container">
            <div className="settings-header">
              <h2 className="mb-4">Settings</h2>
            </div>
            <div className="row">
              <div className="col-md-3 settings-option">
                <ul id="settings-nav" className="d-flex flex-column gap-1">
                  <li data-step="step1" className="active">Profile</li>
                  {/* <li data-step="step2">Billing</li> */}
                </ul>
              </div>
              <div className="col-md-9">
                <div id="step1" className="step-section profile-cnt w-100">
                  <form className="w-100" onSubmit={e => {
                  e.preventDefault()
                  validationUser.handleSubmit()
                  return false
                }}
                action="#">
                    <div className="preference-section main-cnt-section w-100" style={{maxHeight:"calc(100vh - 150px)",overflowY:"auto"}}>
                      <div className="settings-grid mb-3">
                        
                        <div>
                          <label htmlFor="nickname" className="form-label">What should we call you?<span className="text-danger">*</span></label>
                            <input
                              name="user_name"
                              className="form-control"
                              type="text"
                              id="user_name"
                              onChange={validationUser.handleChange}
                              onBlur={validationUser.handleBlur}
                              value={validationUser.values.user_name || ""}
                              invalid={
                                validationUser.touched.user_name &&
                                validationUser.errors.user_name
                                  ? true
                                  : false
                              }
                            />
                            {validationUser.touched.user_name &&
                            validationUser.errors.user_name ? ( <div className="text-danger mb-2">{validationUser.errors.user_name}</div>) : null}
                        </div>
                        <div>
                          <label htmlFor="fullName" className="form-label">Company's name<span className="text-danger">*</span></label>
                            <input
                              name="company_name"
                              className="form-control"
                              type="text"
                              id="company_name"
                              onChange={validationUser.handleChange}
                              onBlur={validationUser.handleBlur}
                              value={validationUser.values.company_name || ""}
                              invalid={
                                validationUser.touched.company_name &&
                                validationUser.errors.company_name
                                  ? true
                                  : false
                              }
                            />
                            {validationUser.touched.company_name &&
                            validationUser.errors.company_name ? ( <div className="text-danger mb-2">{validationUser.errors.company_name}</div>) : null}
                        </div>
                      </div>
                      <div className="profile-description mb-3">
                        <div className="w-100">
                          <label htmlFor="addtess" className="form-label">Email</label>
                              <input type="text" name="email"  className="form-control" value={localStorage.getItem('useremail') || null}  disabled />
                        </div>
                      </div>
                      <div className="profile-description mb-3" style={{display:'none'}}>
                        <div className="w-100">
                          <label htmlFor="addtess" className="form-label">Address</label>
                              <textarea 
                              className="form-control text-area-input"
                              rows="3" 
                              id="user_address"
                              name="user_address"
                              
                              value={validationUser.values.user_address}
                              onChange={validationUser.handleChange}
                              onBlur={validationUser.handleBlur} />
                            {validationUser.touched.user_address &&
                            validationUser.errors.user_address ? ( <div className="text-danger mb-2">{validationUser.errors.user_address}</div>) : null}
                        </div>
                      </div>
                      <div className="settings-grid mb-3" style={{display:'none'}}>
                        <div>
                          <label htmlFor="City" className="form-label">City</label>
                            <input
                              name="user_city"
                              className="form-control"
                              type="text"
                              id="user_city"
                              onChange={validationUser.handleChange}
                              onBlur={validationUser.handleBlur}
                              value={validationUser.values.user_city || ""}
                              invalid={
                                validationUser.touched.user_city &&
                                validationUser.errors.user_city
                                  ? true
                                  : false
                              }
                            />
                            {validationUser.touched.user_city &&
                            validationUser.errors.user_city ? ( <div className="text-danger mb-2">{validationUser.errors.user_city}</div>) : null}
                        </div>
                        <div>
                          <label htmlFor="state" className="form-label">State</label>
                            <input
                              name="user_state"
                              className="form-control"
                              type="text"
                              id="user_state"
                              onChange={validationUser.handleChange}
                              onBlur={validationUser.handleBlur}
                              value={validationUser.values.user_state || ""}
                              invalid={
                                validationUser.touched.user_state &&
                                validationUser.errors.user_state
                                  ? true
                                  : false
                              }
                            />
                            {validationUser.touched.user_state &&
                            validationUser.errors.user_state ? ( <div className="text-danger mb-2">{validationUser.errors.user_state}</div>) : null}
                        </div>
                      </div>
                      <div className="settings-grid mb-3" style={{display:'none'}}>
                        <div>
                          <label htmlFor="user_country" className="form-label">country</label>
                            <input
                              name="user_country"
                              className="form-control"
                              type="text"
                              id="user_country"
                              onChange={validationUser.handleChange}
                              onBlur={validationUser.handleBlur}
                              value={validationUser.values.user_country || ""}
                              invalid={
                                validationUser.touched.user_country &&
                                validationUser.errors.user_country
                                  ? true
                                  : false
                              }
                            />
                            {validationUser.touched.user_country &&
                            validationUser.errors.user_country ? ( <div className="text-danger mb-2">{validationUser.errors.user_country}</div>) : null}
                        </div>
                        <div>
                          <label htmlFor="Phone" className="form-label">Phone</label>
                            <input
                              name="user_phone_num"
                              className="form-control"
                              type="number"
                              id="user_phone_num"
                              onChange={validationUser.handleChange}
                              onBlur={validationUser.handleBlur}
                              value={validationUser.values.user_phone_num || ""}
                              invalid={
                                validationUser.touched.user_phone_num &&
                                validationUser.errors.user_phone_num
                                  ? true
                                  : false
                              }
                            />
                            {validationUser.touched.user_phone_num &&
                            validationUser.errors.user_phone_num ? ( <div className="text-danger mb-2">{validationUser.errors.user_phone_num}</div>) : null}
                        </div>
                      </div>
                      {/* <div className="job-selection mb-3">
                        <label className="form-label">Select your job to help us personalize things.<span className="text-danger">*</span></label>
                        <div class="mb-0 w-100 mt-2">
                          <div class="d-flex gap-3 justify-content-center ">
                              {optionsInsights.map(({ pk_ins_id, ins_name, icon, image, is_active, description }) => {
                              if (is_active === 1) {
                                const isSelected = validationUser.values.insight_ids.includes(pk_ins_id);
                                return (
                                  <a className={`avatar-items ${isSelected ? 'active position-relative' : 'position-relative'}`}
                                    key={pk_ins_id}
                                    onClick={() => {
                                    const prev = validationUser.values.user_insights;
                                    const newValue = isSelected ? [] : [pk_ins_id];
                                    validationUser.setFieldValue("insight_ids", newValue);
                                  }}
                                    // onClick={() => {
                                    //     const prev = validationUser.values.insight_ids;
                                    //     validationUser.setFieldValue(
                                    //       "insight_ids",
                                    //       isSelected
                                    //         ? prev.filter((v) => v !== pk_ins_id)
                                    //         : [...prev, pk_ins_id]
                                    //     );
                                    //   }}
                                    >
                                    <div className="text-center">
                                        <img src={image || UserProfile} alt="" style={{ opacity: 0.5 }} />
                                        <div dangerouslySetInnerHTML={{ __html: description }}></div>
                                      
                                    </div>
                                    <div className={`${isSelected ? 'selected' : ''}`}>
                                      {isSelected ? <i className="fa-solid fa-check"></i> : null}
                                    </div>
                                  </a>);
                                    } else {
                                      return (
                                          <a className="avatar-items disable position-relative">
                                            <div className="ribbon-cust">
                                                          <span className="ribbon-text text-white text-center">Comming Soon</span>
                                                      </div>
                                            <div className="text-center">
                                              <img src={image || UserProfile} alt="" style={{ opacity: 0.5 }} />
                                              <div dangerouslySetInnerHTML={{ __html: description }}></div>
                                              
                                            </div>
                                          </a>
                                      );
                                    }
                                  })}
                            
                            <a class="avatar-items disable">
                              <div class="text-center d-flex flex-column justify-content-center h-100">
                                <h6 class="mb-0 text-muted" style={{ fontWeight: 500, fontSize: '18px', color: '#333' }}>  More to be <br/> Revealed Soon</h6>
                              </div>
                            </a>


                          </div>
                        </div>
                        {validationUser.touched.insight_ids &&
                            validationUser.errors.insight_ids ? ( <div className="text-danger mb-2">{validationUser.errors.insight_ids}</div>) : null}
                      
                      </div> */}
                      <div className="w-100 d-flex justify-content-end">
                        <button type="submit" className="btn btn-dark">Save</button>
                      </div>
                    </div>
                  </form>
                </div>
                <div id="step2" className="step-section billing-cnt w-100" style={{ display: "none" }}>
                  <div className="main-cnt-section w-100">
                    <div className="d-flex align-items-start gap-3 w-100">
                      <div className="w-100">
                        {UpgradeProcess ? (
                          <>
                            <div className="d-flex justify-content-between">
                              <div className="plan-indicator d-flex gap-2 align-items-center">
                                <i className="fa-solid fa-feather-pointed"></i>
                                <h5 className="mb-0 fw-bold">For personal use</h5>
                              </div>
                              <div className="mt-3 mt-md-0">
                                <button className="btn common-btn fw-semibold px-4" disabled onClick={() =>{setUpgradeProcess(!UpgradeProcess)}}>Upgrade plan</button>
                              </div>
                            
                            </div>
                            <ul className="list-unstyled mt-3 mb-0 d-flex flex-column gap-2">
                              {[
                                "Multi-Platform Access",
                                "Data Reporting & Visualization",
                                "AttestaAI-Powered Insights",
                                "Content & Media Analysis"
                              ].map((item, index) => (
                                <li key={index} className="d-flex gap-2 align-items-center">
                                  <i className="fa-regular fa-circle-check"></i>{item}
                                </li>
                              ))}
                            </ul> 
                          </>
                          ) 
                          : 
                          (

                            
                            <div className="payment-step active w-100" id="paymentStep2">
                              {(status && status === "success" || status === "failed")? 
                                <>
                                  <div className="d-flex gap-2 align-items-center">
                                    <button className="back-btn btn" onClick={() => {handleResetPaymentStatus()}}>
                                      <i className="fa-solid fa-arrow-left"></i>
                                    </button>
                                    <h3 className="mb-0">Payment</h3>
                                  </div>

                                  <div className="payment-tabs mt-4 px-3">
                                    {status === "success" && (
                                      <>
                                        <h4 className="payment-status success">Payment Successful!</h4>
                                        <div className="payment-details">
                                          <p><strong>Name:</strong> {localStorage.getItem('username')}</p>
                                          <p><strong>Email:</strong> {localStorage.getItem('useremail')}</p>
                                          <p><strong>Order ID:</strong> {result?.orderID || "N/A"}</p>
                                          <p><strong>Amount:</strong> {result?.amount || "0.00"} {result?.currency || ""}</p>
                                        </div>
                                      </>
                                    )}

                                    {status === "failed" && (
                                      <>
                                        <h4 className="payment-status failed">Payment Failed!</h4>
                                        <div className="payment-details">
                                          <p><strong>Name:</strong> {localStorage.getItem('username')}</p>
                                          <p><strong>Email:</strong> {localStorage.getItem('useremail')}</p>
                                          <p><strong>Status:</strong> {result?.status || "N/A"}</p>
                                          <p><strong>Reason:</strong> {result?.reason || "N/A"}</p>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </>
                              :
                                <>    
                                <div className="d-flex gap-2 align-items-center">
                                  <button className="back-btn btn" onClick={() =>{setUpgradeProcess(!UpgradeProcess)}}><i
                                      className="fa-solid fa-arrow-left"></i></button>
                                  <h3 className="mb-0">Upgrade Plan</h3>
                                </div>

                                <div className="payment-tabs mt-3">
                                  {/* Nav tabs */}
                                  <ul className="nav nav-pills nav-justified w-50 mx-auto" role="tablist">
                                    <li className="nav-item" role="presentation">
                                      <button
                                        className={`nav-link ${activeTab === "personal" ? "active" : ""}`}
                                        onClick={() => setActiveTab("personal")}
                                        role="tab"
                                      >
                                        Personal
                                      </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                      <button
                                        className={`nav-link ${activeTab === "enterprise" ? "active" : ""}`}
                                        onClick={() => setActiveTab("enterprise")}
                                        role="tab"
                                      >
                                        Enterprise
                                      </button>
                                    </li>
                                  </ul>

                                  {/* Tab panes */}
                                  <div className="tab-content mt-4">
                                    {activeTab === "personal" && (
                                      <div className="tab-pane p-3 pb-0 active" id="home-1" role="tabpanel">
                                        <div className="payment-process active" id="paymentProcess1">
                                          <div className="row justify-content-center">
                                            <div className="col-lg-6">
                                              <div className="pay-file-details">
                                                <div style={{ display: paypalClicked ? 'none' : 'block' }}>
                                                  <h3 className="mb-3">Pay as you go</h3>
                                                  <div>
                                                    <h1 className="mb-0">{selectedPrice}</h1>
                                                    <p>{perCreditRate}</p>
                                                  </div>
                                                </div>

                                                <div className="payment-credits my-3 " style={{ display: paypalClicked ? 'none' : 'block' }}>
                                                  <ul>
                                                    {optionsPlans.map((option) => {
                                                      //const ratePerCredit = (option.plan_pages / option.plan_amount).toFixed(1);

                                                      return (
                                                        <li key={option.pk_token_plan_id}>
                                                          <div className="form-check">
                                                            <input
                                                              className="form-check-input"
                                                              type="radio"
                                                              name="creditOptions"
                                                              id={`option${option.pk_token_plan_id}`}
                                                              data-price={option.plan_amount}
                                                              data-rate={option.plan_per_page_amount}
                                                              data-details={JSON.stringify(option)}
                                                              onChange={handleCreditChange}
                                                              defaultChecked={option.pk_token_plan_id === 1}
                                                            />
                                                            <label
                                                              className="form-check-label"
                                                              htmlFor={`option${option.pk_token_plan_id}`}
                                                            >
                                                              {option.plan_pages} credits
                                                            </label>
                                                          </div>
                                                          <div>
                                                            <p>
                                                              ${option.plan_amount} <span>{option.plan_per_page_amount}/credit</span>
                                                            </p>
                                                          </div>
                                                        </li>
                                                      );
                                                    })}
                                                  </ul>
                                                </div>
                                                  <div style={{ height: paypalClicked ? "400px" : "400px", overflowY: "auto" }}>
                                                  {seletedPlan && parseFloat(seletedPlan.plan_amount) > 0 && (
                                                   
                                                        <PayPalButtonUI 
                                                          amount={parseFloat(seletedPlan.plan_amount)} 
                                                          currency={process.env.REACT_APP_PAYPAL_CURRENCY}
                                                          tokens={seletedPlan.plan_pages} 
                                                          userId={localStorage.getItem('userid')} 
                                                          planId={seletedPlan.pk_token_plan_id}
                                                          onSuccess={handleSuccess}
                                                          onFailure={handleFailure}
                                                          onButtonClick={() => setPaypalClicked(true)} // Pass this
                                                      />
                                                    
                                                    )}
                                                  </div>
                                                

                                                <div className="pay-dis">
                                                  <div className="d-flex gap-1">
                                                    <svg className="mx-0 text-neutral-ink-500 inline" width="18" height="18"
                                                      viewBox="0 0 18 18" fill="none">
                                                      <path
                                                        d="M6.35583 14.5475H4.28833C3.82667 14.5475 3.4525 14.1733 3.4525 13.7117V11.6433C3.4525 11.4217 3.36417 11.2092 3.2075 11.0525L1.745 9.59C1.41833 9.26333 1.41833 8.73417 1.745 8.40833L3.2225 6.93083C3.37 6.78333 3.4525 6.58417 3.4525 6.37583V4.28833C3.4525 3.82667 3.82667 3.4525 4.28833 3.4525H6.35667C6.57833 3.4525 6.79083 3.36417 6.9475 3.2075L8.41 1.745C8.73667 1.41833 9.26583 1.41833 9.59167 1.745L11.0542 3.2075C11.2108 3.36417 11.4233 3.4525 11.645 3.4525H13.7133C14.175 3.4525 14.5492 3.82667 14.5492 4.28833V6.35667C14.5492 6.57833 14.6375 6.79083 14.7942 6.9475L16.2567 8.41C16.5833 8.73667 16.5833 9.26583 16.2567 9.59167L14.7942 11.0542C14.6375 11.2108 14.5492 11.4233 14.5492 11.645V13.7133C14.5492 14.175 14.175 14.5492 13.7133 14.5492H11.645C11.4233 14.5492 11.2108 14.6375 11.0542 14.7942L9.59167 16.2567C9.265 16.5833 8.73583 16.5833 8.41 16.2567L6.9475 14.7942C6.79 14.635 6.5775 14.5475 6.35583 14.5475Z"
                                                        stroke="#5C5D6B" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round"></path>
                                                      <path d="M11.5 7.75L8.375 10.875L6.5 9" stroke="#5C5D6B"
                                                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                                      </path>
                                                    </svg>
                                                    <p className="mb-0" style={{color: "#505050"}}><span
                                                        style={{fontWeight: "600"}}>Pay
                                                        only once.</span> Credit available forever</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    {activeTab === "enterprise" && (
                                        <div className=" row justify-content-center">
                                          <div className="col-lg-6">
                                            <div className="pay-file-details " style={{minHeight : "540px"}}>
                                              <h3 className="mb-3">Enterprise</h3>

                                              <div className=" ">
                                                <h1 className="mb-1">Let’s talk</h1>
                                                <p> Custom for your need</p>
                                              </div>

                                              <button className="w-100 btn buy-btn" onClick={() => setShowModal(true)}>Contact US</button>
                                              {showModal && (
                                                <div
                                                  className="modal fade show"
                                                  style={{ display: "block" }}
                                                  tabIndex="-1"
                                                >
                                                  <div className="modal-dialog modal-dialog-centered">
                                                    <div className="modal-content rounded-4 shadow-lg">
                                                       <form onSubmit={e => {
                                                          e.preventDefault()
                                                          formik.handleSubmit()
                                                          return false
                                                        }}
                                                        action="#">
                                                      {/* <form onSubmit={formik.handleSubmit}> */}
                                                        <div className="modal-header border-0" style={{background: '#ddd'}}>
                                                          <h5 className="modal-title fw-bold text-black">Contact Form</h5>
                                                          <button
                                                            type="button"
                                                            className="contact-form btn-close"
                                                            onClick={() => setShowModal(false)}
                                                          ></button>
                                                        </div>
                                                        <div className="modal-body px-4 pb-4">
                                                          <h5 className="text-center">Enter your email and we'll contact you asap.</h5>
                                                          <div className="mb-3 w-100">
                                                            <input
                                                              name="contact_email"
                                                              className="form-control lg-input"
                                                              placeholder="Enter your personal or work email"
                                                              type="contact_email"
                                                              id="contact_email"
                                                              onChange={formik.handleChange}
                                                              onBlur={formik.handleBlur}
                                                              value={formik.values.contact_email || ""}
                                                              invalid={
                                                                formik.touched.contact_email &&
                                                                formik.errors.contact_email
                                                                  ? true
                                                                  : false
                                                              }
                                                            />
                                                            {formik.touched.contact_email &&
                                                              formik.errors.contact_email ? ( <div className="text-danger mb-2">{formik.errors.contact_email}</div>) : null}
                                                          </div>
                                                          <div className="mb-3 w-100">
                                                            <textarea
                                                              name="contact_message"
                                                              className={`form-control lg-input`}
                                                              placeholder="message"
                                                              style={{ height: "120px" }}
                                                              value={formik.values.contact_message}
                                                              onChange={formik.handleChange}
                                                              onBlur={formik.handleBlur}
                                                              invalid={
                                                                formik.touched.contact_message &&
                                                                formik.errors.contact_message
                                                                  ? true
                                                                  : false
                                                              }
                                                            ></textarea>
                                                            {formik.touched.contact_message &&
                                                              formik.errors.contact_message ? ( <div className="text-danger mb-2">{formik.errors.contact_message}</div>) : null}
                                                          </div>
                                                          <div className="d-flex justify-content-center">
                                                            <button className="btn common-btn w-30" id="" type='submit' disabled={isSubmitting}>
                                                              Send Request
                                                            </button>
                                                            
                                                          </div>
                                                        </div>
                                                      </form>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}

                                              <div className="enterprise-list">
                                                <ul>
                                                  <li>Bulk PDF Upload & Processing</li>
                                                  <li> Advanced Data Extraction & Summarization</li>
                                                  <li> Actionable Recommendations</li>
                                                  <li>Secure & Compliant Delivery</li>
                                                </ul>
                                              </div>
                                            </div>

                                          </div>
                                        </div>
                                    )}
                                  </div>
                                </div>
                                </>
                              }
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </div>
                  
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;